module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "show-close": false,
      "is-bg-overlay": true
    }
  }, [_c('div', {
    staticClass: "modal-merges",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "do-modal__header"
  }, [(_vm.isMergeCalendar) ? _c('h2', [_vm._v(_vm._s(_vm.$t('vue2.editCalendarMenu.merge_with_calendar')))]) : _c('h2', [_vm._v(_vm._s(_vm.$t('vue2.editCalendarMenu.merge_with_merge_calendars')))]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "do-modal__body"
  }, [(_vm.isLoadingMerges) ? _c('Loader', {
    attrs: {
      "bg-color": "#f6f9fc",
      "isSmall": true
    }
  }) : [(_vm.isMergeCalendar) ? _c('div', [(_vm.calendarsMerged.length > 0) ? _c('label', {
    staticClass: "d-label d-label__divider d-label__divider--top"
  }, [_vm._v(_vm._s(_vm.$t('vue2.editCalendarMenu.is_merged')))]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.calendarsMerged), function(calendar) {
    return _c('li', {
      key: calendar.id,
      staticClass: "modal-merges__item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.unMergeCalendarFromMergeCalendar(calendar)
        }
      }
    }, [_c('label', {
      staticClass: "d-label"
    }, [_vm._v(_vm._s(calendar.name) + "\n                "), _c('span', {
      staticClass: "do-pill marg-05-rem"
    }, [_vm._v(_vm._s(calendar.year))])]), _vm._v(" "), (_vm.theLoaderId === calendar.id) ? _c('div', {
      staticClass: "do-spinner do-spinner--custom-marg"
    }) : _c('div', {
      staticClass: "do-switch do-switch--active"
    })])
  }), 0), _vm._v(" "), _c('label', {
    staticClass: "d-label d-label__divider"
  }, [_vm._v(_vm._s(_vm.$t('vue2.editCalendarMenu.can_be_merged_into')))]), _vm._v(" "), _c('ul', _vm._l((_vm.possibleToMerge), function(calendar) {
    return _c('li', {
      key: calendar.id,
      staticClass: "modal-merges__item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.mergeCalendarFromMergeCalendar(calendar)
        }
      }
    }, [_c('label', {
      staticClass: "d-label"
    }, [_vm._v(_vm._s(calendar.name) + "\n                "), _c('span', {
      staticClass: "do-pill marg-05-rem"
    }, [_vm._v(_vm._s(calendar.year))])]), _vm._v(" "), (_vm.theLoaderId === calendar.id) ? _c('div', {
      staticClass: "do-spinner do-spinner--custom-marg"
    }) : _c('div', {
      staticClass: "do-switch"
    })])
  }), 0)]) : _vm._e(), _vm._v(" "), (!_vm.isMergeCalendar) ? _c('ul', _vm._l((_vm.allMergeCalendars), function(calendar) {
    return _c('li', {
      key: calendar.id,
      staticClass: "modal-merges__item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleMergeCalendar(calendar)
        }
      }
    }, [_c('label', {
      staticClass: "d-label"
    }, [_vm._v(_vm._s(calendar.name)), (calendar.archived) ? _c('span', {
      staticClass: "do-pill do-pill--yellow marg-05-rem"
    }, [_vm._v("Archived")]) : _vm._e()]), _vm._v(" "), (_vm.theLoaderId === calendar.id) ? _c('div', {
      staticClass: "do-spinner do-spinner--custom-marg"
    }) : _c('div', {
      staticClass: "do-switch",
      class: {
        'do-switch--active': calendar.vIsMerged
      }
    })])
  }), 0) : _vm._e()]], 2), _vm._v(" "), _c('div', {
    staticClass: "do-modal__footer"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.done')))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-02278584!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Calendars/CalendarMergeModal.vue
// module id = 1729
// module chunks = 1